
import { setGetTransactionReportAction } from '../action';
import { getTransactionReport } from '../api/getTransactionReport';

export const setGetTransactionReport = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await getTransactionReport(params);
     
            dispatch(setGetTransactionReportAction({
                list: data.list,
                totalPage: data.totalPage
            }));
        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}